import { Text } from '@consta/uikit/Text'
import classnames from 'classnames'
import type { FC, PropsWithChildren } from 'react'

import css from './GraphContainer.css'

type GraphContainerProps = {
  xAxisLabel: string
  yAxisLeftLabel: string
  yAxisRightLabel?: string
  className?: string
}

export const GraphContainer: FC<PropsWithChildren<GraphContainerProps>> = ({
  xAxisLabel,
  yAxisLeftLabel,
  yAxisRightLabel,
  children,
  className,
}) => {
  const withoutRight = yAxisRightLabel == null
  return (
    <div className={classnames(css.container, className, { [css.withoutRight]: withoutRight })}>
      <Text className={css.xLabel} size="xs" view="secondary">
        {xAxisLabel}
      </Text>
      <Text className={css.yLabelLeft} size="xs" view="secondary">
        {yAxisLeftLabel}
      </Text>
      {!withoutRight && (
        <Text className={css.yLabelRight} size="xs" view="secondary">
          {yAxisRightLabel}
        </Text>
      )}
      <div className={css.graph}>{children}</div>
    </div>
  )
}
